import { EDSV2ArrayResponse } from '@/types/eds/api/responses/EDSV2Response';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { EDSAdapterServiceNormalizeConfiguration } from '@/features/eds/services/types/EDSAdapterServiceInjectionConfig';
import { EntityDetailsModel } from '../types/entityDetailsData';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import EdsAdapterService from '@/features/eds/services/EdsAdapterService/EdsAdapterService';
import { EntityDetailsSliceState } from '@/features/entityDetails/store/entityDetailsSlice';

export async function normalizeContactList(
  resData: EDSV2ArrayResponse,
  config?: EDSAdapterServiceNormalizeConfiguration,
): Promise<EntityDetailsModel[]> {
  const contactsNormalizedList: NormalizedV2Response[] = await EdsAdapterService.normalize(resData, config);

  const normalizedContactList: EntityDetailsSliceState['contactList'] = [];

  for (const contact of contactsNormalizedList) {
    const personOrBusinessData =
      ((contact.entities[EdsEntityCodes.Party] as NormalizedV2Response).entities[
        EdsEntityCodes.Person
      ] as NormalizedV2Response) ??
      ((contact.entities[EdsEntityCodes.Party] as NormalizedV2Response).entities[
        EdsEntityCodes.Business
      ] as NormalizedV2Response);

    const personOrBusinessDataAddressList =
      (personOrBusinessData.entities[EdsEntityCodes.Addresses] as NormalizedV2Response[] | undefined) ??
      (personOrBusinessData.entities[EdsEntityCodes.Addresses] as NormalizedV2Response[] | undefined);

    const entityAddressList =
      personOrBusinessDataAddressList?.map((item) => ({ ...item, addressEditId: item.id }) as NormalizedV2Response) ??
      [];

    normalizedContactList.push({
      entityDetailsData: contact,
      personOrBusinessData,
      contactInformationData: personOrBusinessData.entities[EdsEntityCodes.ContactInformation] as NormalizedV2Response,
      entityAddressList,
    });
  }

  return normalizedContactList;
}
